// Three supported languages, each with a regional code matching the
// Google Sheet column headers. Locale (UI lang) maps 1-1 to a known lang.
export const LANGS = ["fr-FR", "bg-BG", "en-GB"] as const;
export type Lang = (typeof LANGS)[number];

export const LOCALES = ["fr", "bg", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export const LOCALE_TO_LANG: Record<Locale, Lang> = {
  fr: "fr-FR",
  bg: "bg-BG",
  en: "en-GB",
};

export const LANG_TO_LOCALE: Record<Lang, Locale> = {
  "fr-FR": "fr",
  "bg-BG": "bg",
  "en-GB": "en",
};

// Localized language names: LANG_NAMES[displayedIn][lang]
export const LANG_NAMES: Record<Locale, Record<Lang, string>> = {
  fr: { "fr-FR": "français", "bg-BG": "bulgare", "en-GB": "anglais" },
  bg: { "fr-FR": "френски", "bg-BG": "български", "en-GB": "английски" },
  en: { "fr-FR": "French", "bg-BG": "Bulgarian", "en-GB": "English" },
};

export const LANG_SHORT: Record<Lang, string> = {
  "fr-FR": "FR",
  "bg-BG": "BG",
  "en-GB": "EN",
};

// Native (endonym) names — always shown in the language itself, used in
// the first-visit wizard so a user can recognise their own language even
// if the UI is currently in another locale.
export const LANG_NATIVE: Record<Lang, string> = {
  "fr-FR": "français",
  "bg-BG": "български",
  "en-GB": "english",
};

// Country code → UI locale (used for IP-based first-visit detection).
// We keep this small and only map to languages we actually support.
export const COUNTRY_TO_LOCALE: Record<string, Locale> = {
  FR: "fr", BE: "fr", CH: "fr", LU: "fr", MC: "fr", CA: "fr",
  BG: "bg",
  // Everywhere else → handled by fallback (English).
};

// Default target = the most common pairing for each locale.
export function defaultTargetFor(loc: Locale): Lang {
  if (loc === "fr") return "bg-BG";
  if (loc === "bg") return "fr-FR";
  return "bg-BG"; // en → bg
}
